import Udesk from 'Udesk';
import UdeskLocales from 'UdeskLocales';
import React from 'react';
import AudioCallBasicInfoComponent from './component';
import { Tabs, Icon, Button, Select } from 'udesk-ui';
import BusinessRecordsView from '../business-records-view';
import CallTextView from '../call-text-view';
import { TimelySceneTree } from 'Component/pages/wechat-qa/chart-record/detail/template';
import AssociatedTicket from 'src/components/common/AssociatedTicket';
import { transformToTickets } from 'src/components/common/AssociatedTicket/utils';
import CustomerInformation from 'src/components/common/CustomerInformation';
import DialogInformation from 'src/components/common/DialogInformation';
import EditableCustomFields from 'src/components/common/EditableCustomFields';
import HandleTime from 'src/components/common/HandleTime';
import { hasFeature } from 'src/util/permit';
import './style.scss';

export default class AudioCallBasicInfo extends AudioCallBasicInfoComponent {
    render() {
        let {
            detail,
            width,
            isBusinessRecordsVisible,
            inspectDataSource,
            isWechatQa,
            visible,
            changeBaseInfoOnOff,
            isTimelyScene = false,
            timelySceneList = [], // 触发场景
        } = this.props;

        let { locales } = this;

        let {
            basicReaf,
            /* lineFlag, */ phoneFlag,
            /* content */ highlightPoint,
            ticketIndex,
            isEditable,
            editableLoading,
        } = this.privates;

        const isTicket = inspectDataSource === Udesk.enums.inspectDataSources.ticket.id;

        const tickets = transformToTickets(detail);

        return (
            <div
                className="audio-call-basic-info-page-v2"
                style={{ width: visible ? width : 0 }}
                ref={basicReaf}
            >
                <Tabs
                    style={{ width: '100%' }}
                    defaultActiveKey={`businessRecords-${detail.id}`}
                    tabBarExtraContent={
                        typeof changeBaseInfoOnOff === 'function' &&
                        visible && (
                            <Button
                                onClick={changeBaseInfoOnOff}
                                type="text"
                                size="small"
                                icon={<Icon type="MenuFoldOutlined" antdIcon={true} />}
                            ></Button>
                        )
                    }
                >
                    <If condition={!phoneFlag}>
                        <Tabs.TabPane
                            tab={
                                {
                                    [Udesk.enums.inspectDataSources.textDialogue.id]:
                                        locales.components.pages.appealChekingTask.list.dialogInfo,
                                    [Udesk.enums.inspectDataSources.realTimeTextDialogue.id]:
                                        locales.components.pages.appealChekingTask.list.dialogInfo,
                                    [Udesk.enums.inspectDataSources.wechatDialogue.id]:
                                        locales.components.pages.appealChekingTask.list.wechatInfo,
                                    [Udesk.enums.inspectDataSources.ticket.id]:
                                        locales.components.pages.appealChekingTask.list.ticketInfo,
                                }[inspectDataSource] ||
                                locales.components.pages.appealChekingTask.list.callInfo
                            }
                            key={`callInfos-${detail.id}`}
                        >
                            <div className="audio-text-view">
                                <If
                                    condition={
                                        detail && detail.fieldList && detail.fieldList.length > 0
                                    }
                                >
                                    <CallTextView
                                        thirdParty={this.props.thirdParty}
                                        callInfoList={detail.fieldList}
                                        fieldValueMap={detail.fieldValueMap}
                                        editableAgent
                                        callId={detail.callId}
                                        isEditable={isEditable}
                                        editableLoading={editableLoading}
                                    />
                                </If>
                            </div>
                        </Tabs.TabPane>
                    </If>

                    <If condition={!isWechatQa}>
                        <If condition={isBusinessRecordsVisible && !phoneFlag}>
                            {!isTicket ? (
                                <Tabs.TabPane
                                    tab={
                                        locales.components.pages.appealChekingTask.list
                                            .businessRecords
                                    }
                                    key={`businessRecords-${detail.id}`}
                                >
                                    <div
                                        className="audio-text-view"
                                        style={{ display: phoneFlag ? 'none' : 'block' }}
                                    >
                                        <If condition={detail.noteInfoExtension}>
                                            <BusinessRecordsView
                                                noteInfoExtension={detail.noteInfoExtension}
                                            />
                                        </If>
                                    </div>
                                </Tabs.TabPane>
                            ) : null}

                            {!isTicket ? (
                                <Tabs.TabPane
                                    tab={
                                        /* 工单信息 */ UdeskLocales['current'].components
                                            .audioCallBasicInfoV2.template.workOrderInformation
                                    }
                                    key={`ticket-${detail.id}`}
                                >
                                    <div
                                        className="audio-text-view"
                                        style={{ display: phoneFlag ? 'none' : 'block' }}
                                    >
                                        {Array.isArray(detail.ticketInfoList) && (
                                            <>
                                                {detail.ticketInfoList.length > 1 && (
                                                    <Select
                                                        options={detail.ticketInfoList.map(
                                                            (t, i) => ({
                                                                label:
                                                                    t.fieldNum ||
                                                                    `${
                                                                        /* 工单 */ UdeskLocales[
                                                                            'current'
                                                                        ].components
                                                                            .audioCallBasicInfoV2
                                                                            .template.workOrder
                                                                    }${i + 1}`,
                                                                value: i,
                                                            })
                                                        )}
                                                        onChange={this.actions.onTicketChange}
                                                        style={{
                                                            width: '100%',
                                                            marginTop: 8,
                                                            padding: '0 8px',
                                                        }}
                                                        value={ticketIndex}
                                                    />
                                                )}
                                                {detail.ticketInfoList.length > 0 && (
                                                    <If
                                                        condition={
                                                            detail.ticketInfoList[ticketIndex]
                                                        }
                                                    >
                                                        <div>
                                                            <CallTextView
                                                                thirdParty={this.props.thirdParty}
                                                                callInfoList={
                                                                    detail.ticketInfoList[
                                                                        ticketIndex
                                                                    ].fieldList
                                                                }
                                                                fieldValueMap={
                                                                    detail.ticketInfoList[
                                                                        ticketIndex
                                                                    ].fieldValueMap
                                                                }
                                                            />
                                                        </div>
                                                    </If>
                                                )}
                                            </>
                                        )}
                                    </div>
                                </Tabs.TabPane>
                            ) : null}
                        </If>
                        {/* <If condition={!phoneFlag}>
                            <TabPane tab={locales.components.pages.semanticTags.title} key='audioText' style={{ display: phoneFlag ? 'none' : 'block' }}>
                                <SemanticMarkInfo content={content} taskId={taskId} />
                            </TabPane>
                        </If> */}
                    </If>

                    {[
                        Udesk.enums.inspectDataSources.voiceCall.id,
                        Udesk.enums.inspectDataSources.textDialogue.id,
                    ].includes(inspectDataSource) && hasFeature('ticket:relate:root') ? (
                        <Tabs.TabPane
                            tab={
                                /* 关联工单 */ UdeskLocales['current'].components
                                    .audioCallBasicInfoV2.template.associatedWorkOrder
                            }
                            key={`associatedTicket-${detail.id}`}
                        >
                            <div
                                className="audio-text-view"
                                style={{ display: phoneFlag ? 'none' : 'block' }}
                            >
                                <AssociatedTicket tickets={tickets} />
                            </div>
                        </Tabs.TabPane>
                    ) : null}

                    {[
                        Udesk.enums.inspectDataSources.voiceCall.id,
                        Udesk.enums.inspectDataSources.textDialogue.id,
                        Udesk.enums.inspectDataSources.ticket.id,
                    ].includes(inspectDataSource) ? (
                        <Tabs.TabPane
                            tab={
                                /* 客户信息 */ UdeskLocales['current'].components
                                    .audioCallBasicInfoV2.template.customerInformation
                            }
                            key={`customerInformation-${detail.id}`}
                        >
                            <div
                                className="audio-text-view"
                                style={{ display: phoneFlag ? 'none' : 'block' }}
                            >
                                <CustomerInformation callId={detail.callId} />
                            </div>
                        </Tabs.TabPane>
                    ) : null}

                    {isTicket ? (
                        <Tabs.TabPane
                            tab={
                                /* 自定义字段 */ UdeskLocales['current'].components
                                    .audioCallBasicInfoV2.template.customFields
                            }
                            key={`customFiledList-${detail.id}`}
                        >
                            <EditableCustomFields
                                callId={detail.callId}
                                isEditable={isEditable}
                                editableLoading={editableLoading}
                                customFields={
                                    detail.noteInfoExtension?.noteInfo?.note_custom_fields
                                }
                            />
                        </Tabs.TabPane>
                    ) : null}

                    {[Udesk.enums.inspectDataSources.ticket.id].includes(inspectDataSource) ? (
                        <Tabs.TabPane
                            tab={
                                /* 处理时间 */ UdeskLocales['current'].components
                                    .audioCallBasicInfoV2.template.processingTime
                            }
                            key={`handleTime-${detail.id}`}
                        >
                            <div
                                className="audio-text-view"
                                style={{ display: phoneFlag ? 'none' : 'block' }}
                            >
                                <HandleTime
                                    customFields={
                                        detail.noteInfoExtension?.noteInfo?.note_custom_time_fields
                                    }
                                />
                            </div>
                        </Tabs.TabPane>
                    ) : null}

                    {isTicket && (
                        <Tabs.TabPane
                            tab={
                                /* 关联通话/对话 */ locales.components.audioCallBasicInfoV2.template
                                    .associatedCallConversation
                            }
                            key={`relatedDetails-${detail.id}`}
                        >
                            <div
                                className="audio-text-view"
                                style={{ display: phoneFlag ? 'none' : 'block' }}
                            >
                                <If condition={detail.noteInfoExtension}>
                                    <BusinessRecordsView
                                        noteInfoExtension={detail.noteInfoExtension}
                                    />
                                </If>
                            </div>
                        </Tabs.TabPane>
                    )}

                    {isTicket ? (
                        <Tabs.TabPane
                            tab={
                                /* 通对话信息 */ UdeskLocales['current'].components.recordDetail
                                    .template.communicationDialogueInformation
                            }
                            key={`dialogInformation-${detail.id}`}
                        >
                            <DialogInformation callId={detail.callId} />
                        </Tabs.TabPane>
                    ) : null}

                    {isTimelyScene && (
                        <Tabs.TabPane
                            tab={
                                /* 触发场景 */ UdeskLocales['current'].components
                                    .audioCallBasicInfoV2.template.triggerScenario
                            }
                            key={`triggerScene-${detail.id}`}
                        >
                            <div className="timely-scene-view">
                                <TimelySceneTree
                                    {...{
                                        timelySceneList,
                                        highlightPoint,
                                        setHighlightPoint: this.actions.setHighlightPoint,
                                    }}
                                />
                            </div>
                        </Tabs.TabPane>
                    )}
                </Tabs>
            </div>
        );
    }
}
